import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { fadeIn } from '../variants'


function Contact() {
  const [name, setName] = useState("")
  const [errorName, setErrorName] = useState(null);
  const [email, setEmail] = useState("")
  const [error, setErrorEmail] = useState(null);
  const [message, setMessage] = useState("");

  function submitForm(form) {
    // window.open("mailto:jasdevbedi.aus@gmail.com?subject=Test%20Email&body=First%20Name:%20" + name + "%20Last%20Name:" + email);
    window.open("mailto:jasdevbedi.aus@gmail.com?subject=Interested%20In%20Working%20Together&body=" + message + "%0D%0AFrom,%0D%0A" + name);
    return false;
  }

  return (
    <div id='contact' className='py-16 lg:section'>
      <div className="container mx-auto lg:mt-44">
        <div className='flex flex-col lg:flex-row'>
          {/* text */}
          <motion.div
            variants={fadeIn('right', 0.3)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: true, amount: 0.3 }}
            className='flex-1 flex justify-start items-center'>
            <div>
              <h4 className='text-xl uppercase text-accent font-medium mb-2 tracking-wide'>
                Get in touch
              </h4>
              <h2 className='text-[45px] lg:text-[90px] leading-none mb-4'>
                Let's work <br /> together!
              </h2>
              <h4 className='semibold text-accent '>Phone</h4>
              <h4 className='h4 semibold text-white hover:text-accent cursor-pointer'>
                <a href="tel:+61492917957">
                  +61 492 917957
                </a>
              </h4>
              <h4 className='semibold text-accent'>Email</h4>
              <h4 className='h4 semibold text-white hover:text-accent cursor-pointer'>
                <a href="mailto:jasdevbedi.aus@gmail.com">
                  jasdevbedi.aus@gmail.com
                </a>
              </h4>
            </div>
          </motion.div>
          {/* form */}
          <motion.form
            variants={fadeIn('left', 0.3)}
            initial="hidden"
            whileInView={'show'}
            viewport={{ once: true, amount: 0.3 }}
            action=""
            onSubmit={(e) => {
              e.preventDefault();
              submitForm(this);
            }}
            className='flex-1 border rounded-2xl flex flex-col gap-y-6 pb-24 p-6 items-start mb-16 lg:mb-0'>
            <input
              className='bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all'
              type="text"
              value={name}
              placeholder="Your name"
              required
              onChange={(e) => {
                if (!/[0-9]/.test(e.target.value)) {
                  setErrorName(null);
                } else {
                  setErrorName("Names are not allowed to contain numbers");
                }
                setName(e.target.value)
              }}
            />
            {errorName !== null ? <small className="text-red-500">{errorName}</small> : null}
            <input
              className='bg-transparent border-b py-3 outline-none w-full placeholder:text-white focus:border-accent transition-all'
              type="email"
              value={email}
              placeholder="Your email"
              required
              onChange={(e) => {
                if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(e.target.value)) {
                  setErrorEmail(null);
                } else {
                  setErrorEmail("Invalid email format");
                }
                setEmail(e.target.value)
              }}
            />
            {error !== null ? <small className="text-red-500">{error}</small> : null}
            <textarea
              className='bg-transparent border-b py-12 outline-none w-full placeholder:text-white focus:border-accent transition-all resize-none mb-12'
              placeholder="Your message"
              value={message}
              required
              onChange={(e) => {
                setMessage(e.target.value)
              }}
            />
            <button className='btn btn-lg'>Send message</button>
          </motion.form>
        </div>

      </div>
    </div>
  )
}

export default Contact
